import { render, staticRenderFns } from "./exhibition-register-company.vue?vue&type=template&id=218acd80&scoped=true&"
import script from "./exhibition-register-company.vue?vue&type=script&lang=js&"
export * from "./exhibition-register-company.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register-company.vue?vue&type=style&index=0&id=218acd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218acd80",
  null
  
)

export default component.exports